import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router';

import { areCredentialsExists } from '../storage/localStorage';
import { SIGN_IN_PATH, HOME_PATH } from '../constants/routes';
import { getAuthInfo, setLoading } from '../store/actions/session';
import LoadingComponent from '../components/core/LoadingComponent/LoadingComponent';

class RedirectRoute extends React.Component {
    componentWillMount() {
        const { setLoading, getAuthInfo } = this.props;

        if (areCredentialsExists()) {
            getAuthInfo();
        } else {
            setLoading(false);
        }
    }

    render() {
        const { isLoading } = this.props;

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        let path = SIGN_IN_PATH;
        if (areCredentialsExists()) {
            path = HOME_PATH;//isUserAdmin ? HOME_PATH : `/api/${PLATFORM_MAP[platform[0]]}/started`;
        }

        return <Route render={() => <Redirect to={path} />} />;
    }
}

RedirectRoute.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    getAuthInfo: PropTypes.func.isRequired,
};

const mapStateToProps = ({
    session: { isLoading },
}) => ({
    isLoading,
});

const mapDispatchToProps = {
    setLoading,
    getAuthInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedirectRoute);



// WEBPACK FOOTER //
// ./src/routes/RedirectRoute.js